import React from 'react';
import { addressFormatter } from '../Address';
import { has } from '../../../Services/helpers';
import NoValue from '../../EmptyStates/NoValue';
import { useCustomer } from '../../../Data/Customers';
import { useSession } from '../../Session';

const MAX_ADDRESS_SEGMENTS = 3;

const Title = ({customer, customerId, className, addressSegments = MAX_ADDRESS_SEGMENTS}) => {
    const {customer: _customer} = useCustomer(customerId, false, true);
    const {showRedesign} = useSession();

    return <span className={className ?? ''}>
        {getTitle(_customer || customer, showRedesign, addressSegments)}
    </span>
}

const getTitle = (customer, showRedesign, addressSegments) => {
    if (!customer) {
        return <NoValue />;
    }
    const formattedAddress = addressFormatter(customer.address, addressSegments);

    if (showRedesign) {
        if (has(formattedAddress)) {
            return formattedAddress;
        }

        if (customer.type === 'Business' && has(customer.businessName)) {
            return customer.businessName;
        }

        if (has(customer.name)) {
            return customer.name;
        }
    }

    if (customer.type === 'Business' && has(customer.businessName)) {
        return customer.businessName;
    }

    if (has(customer.name)) {
        return customer.name;
    }


    if (has(formattedAddress)) {
        return formattedAddress;
    }

    return customer.shortId || customer.id;
}

export default Title;

export {
    getTitle,
}
